/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RewardPostWinConfigText
 */
export interface RewardPostWinConfigText {
    /**
     * Opaque key/value pairs handed to the host app, unmodified, when the player presses the post-win call to action.
     * @type {{ [key: string]: string; }}
     * @memberof RewardPostWinConfigText
     */
    ctaMetadata?: { [key: string]: string; };
    /**
     * Fine print shown beneath the description, set apart from it: offer terms, expiry rules and the like.
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    disclaimer?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    callToAction?: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof RewardPostWinConfigText
     */
    header: string;
}

/**
 * Check if a given object implements the RewardPostWinConfigText interface.
 */
export function instanceOfRewardPostWinConfigText(value: object): value is RewardPostWinConfigText {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('header' in value) || value['header'] === undefined) return false;
    return true;
}

export function RewardPostWinConfigTextFromJSON(json: any): RewardPostWinConfigText {
    return RewardPostWinConfigTextFromJSONTyped(json, false);
}

export function RewardPostWinConfigTextFromJSONTyped(json: any, ignoreDiscriminator: boolean): RewardPostWinConfigText {
    if (json == null) {
        return json;
    }
    return {
        
        'ctaMetadata': json['ctaMetadata'] == null ? undefined : json['ctaMetadata'],
        'disclaimer': json['disclaimer'] == null ? undefined : json['disclaimer'],
        'callToAction': json['callToAction'] == null ? undefined : json['callToAction'],
        'description': json['description'],
        'header': json['header'],
    };
}

export function RewardPostWinConfigTextToJSON(value?: RewardPostWinConfigText | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ctaMetadata': value['ctaMetadata'],
        'disclaimer': value['disclaimer'],
        'callToAction': value['callToAction'],
        'description': value['description'],
        'header': value['header'],
    };
}

